module.exports = __webpack_public_path__ + "img/banner-power.1b4771c9.png";